import React from "react";
import { observer } from "mobx-react";
import { EditionDocumentationViewStore } from "../../store";
import { EditionDocumentationViewForm } from "./EditionDocumentationViewForm";
import { ErrorDialog } from "../../../../common/controls";
import { DownloadIcon } from "../../../../icons";
import { VisibilityIcon } from "../../../../icons";
import { isOriginalCrudStatus, RowCrudStatus } from "../../../common/types";
import { useRootStore } from "../../../../store/contexts";
import { PDFViewerDialog } from "../../../../common/components/PDFViewerDialog";

export type EditionDocumentationViewProps = {
  editionDocumentationViewStore: EditionDocumentationViewStore;
};

export const EditionDocumentationView: React.FC<EditionDocumentationViewProps> =
  observer(({ editionDocumentationViewStore }) => {
    const { langStore } = useRootStore();

    const getViewAction = (
      onDownload: (props: {
        id: string;
        type: string;
        name: string;
        __status__: RowCrudStatus;
      }) => void,
      onViewPdf?: (props: any) => void
    ) => {
      const actions: any[] = [];
      if (onViewPdf) {
        actions.push({
          columnName: "__action_view_pdf",
          onClick: (props: any) =>
            isOriginalCrudStatus(props.__status__) ? onViewPdf(props) : {},
          icon: <VisibilityIcon />,
          label: langStore.viewCommand,
          isActionEnabled: (props: any) =>
            props.name?.toLowerCase().endsWith(".pdf"),
        });
      }
      actions.push({
        columnName: "__action_view",
        onClick: (props: any) =>
          isOriginalCrudStatus(props.__status__) ? onDownload(props) : {},
        icon: <DownloadIcon />,
        label: langStore.downloadCommand,
      });
      return actions;
    };

    return (
      <div>
        <EditionDocumentationViewForm
          worksValues={editionDocumentationViewStore.worksValues}
          authorsDisplay={editionDocumentationViewStore.authorsDisplayValue}
          publisherConfigurationDisplay={
            editionDocumentationViewStore.publisherConfigurationDisplayValue
          }
          territoriesDisplay={
            editionDocumentationViewStore.territoriesDisplayValue
          }
          contractDuration={editionDocumentationViewStore.contractDurationValue}
          contractRenewal={editionDocumentationViewStore.contractRenewalValue}
          contractNumber={editionDocumentationViewStore.contractNumberValue}
          documentName={editionDocumentationViewStore.documentNameValue}
          finalDocumentPdfFiles={
            editionDocumentationViewStore.finalDocumentPdfFiles
          }
          onPrint={(handlePrint: () => void) =>
            editionDocumentationViewStore.printEditionDocumentation(handlePrint)
          }
          onCancel={() =>
            editionDocumentationViewStore.cancelEditionDocumentation()
          }
          onEdit={
            editionDocumentationViewStore.isEditEnabled
              ? () => editionDocumentationViewStore.editEditionDocumentation()
              : undefined
          }
          finalDocumentPdfViewAction={getViewAction(
            (props) =>
              editionDocumentationViewStore.fileDownload(
                props,
                "finalDocumentPdf"
              ),
            (props) =>
              editionDocumentationViewStore.viewFilePdf(
                props,
                "finalDocumentPdf"
              )
          )}
        />
        <ErrorDialog
          open={editionDocumentationViewStore.errorDialogOpened}
          title={editionDocumentationViewStore.errorTitle}
          description={editionDocumentationViewStore.errorDescription}
          onClose={() => editionDocumentationViewStore.closeErrorDialog()}
        />
        <PDFViewerDialog
          open={editionDocumentationViewStore.pdfViewerOpen}
          onClose={() => editionDocumentationViewStore.closePdfViewer()}
          pdfUrl={editionDocumentationViewStore.pdfViewerUrl}
          title={editionDocumentationViewStore.pdfViewerTitle}
        />
      </div>
    );
  });
